/* eslint-disable no-param-reassign */
import { derived, writable } from 'svelte/store';

function createSelectedFacetsStore() {
  const { subscribe, set, update } = writable({});

  return {
    subscribe,
    set,
    toggle: (facet, option) => {
      update(store => {
        if (typeof store[facet] === 'undefined') {
          store[facet] = [option];
        } else if (store[facet].includes(option)) {
          store[facet] = store[facet].filter(opt => opt !== option);
        } else {
          store[facet].push(option);
        }

        return store;
      });
    },
  };
}

export const availableFacets = writable([]);
export const selectedFacets = createSelectedFacetsStore();
export const appliedFacets = derived(selectedFacets, $selectedFacets => {
  return Object.fromEntries(
    Object.entries($selectedFacets).map(([key, values]) => [
      `restrictBy[${key}]`,
      values.join('|'),
    ])
  );
});
export const hasAppliedFacets = derived(appliedFacets, $appliedFacets => {
  return (
    Object.values($appliedFacets).reduce(
      (prev, current) => prev + current.length,
      0
    ) > 0
  );
});
